import { render, staticRenderFns } from "./AddPayout.vue?vue&type=template&id=c6e1a3b2"
import script from "./AddPayout.vue?vue&type=script&lang=js"
export * from "./AddPayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports